import React from 'react';
import {Col, Grid, Row, Tooltip, OverlayTrigger, Glyphicon} from 'react-bootstrap';
import classnames from 'classnames';
import './style.css';

const ProductData = ({productState = '', data = []}) => {
  const renderProductData = () => data.map(curr => (
    <Row key={curr.label.replace(' ', '')}>
      <Col xs={6}>
        {curr.label}
      </Col>
      <Col xs={6}>
        { curr.showToolTip &&
          (
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip" id="tooltip">
                  In order to achieve the Price IT objective,
                  you are required to price your products at this price or below.
                </Tooltip>
              )}
              placement="left"
            >
              <Glyphicon className= 'product-info-glyphicon' glyph="info-sign"/>
            </OverlayTrigger>
          )
        }
        {curr.value}
      </Col>
    </Row>
  ));

  return (
    <Grid bsClass="container" fluid className={classnames('product-data-container', productState)}>

      {renderProductData()}

    </Grid>
  );
};

export default ProductData;



// WEBPACK FOOTER //
// ./src/components/common/product/product-data.jsx